//Library Imports
import { useState } from "react";
import { Radio, Tooltip, Typography } from "antd";
import styled from "styled-components";

//Local Imports
import ShareProfile from "../../../assets/img/icons/shareProfile.svg";

type Props = {
  id: number;
  title: string;
};

const ShareProfileTemplateItem = (props: Props) => {
  // Props
  const { id, title } = props;

  // Local States
  const [ellipsisState, setEllipsistate] = useState(false);

  // Local Variables
  const { Paragraph } = Typography;

  return (
    <Wrapper className="d-flex">
      <div className="checkbox align-self-center">
        <Radio value={id}></Radio>
      </div>
      <div className="thumbnail" style={{ backgroundImage: `url(${ShareProfile})` }}></div>
      <div className="content-area d-flex flex-column align-items-start align-self-center">
        <div className="name">Share Profile Template</div>
        <div className="subject">
          <Tooltip placement="top" title={ellipsisState ? props?.title : undefined}>
            <Paragraph className="camp-name" ellipsis={{ onEllipsis: setEllipsistate }}>
              {title}
            </Paragraph>
          </Tooltip>
        </div>
      </div>
    </Wrapper>
  );
};

export default ShareProfileTemplateItem;

const Wrapper = styled.div`
  background-color: #fff;
  box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
  border-radius: 7px;
  padding: 12px 16px;
  margin: 0 16px 8px 16px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 5px;
    padding: 8px 10px;
  }
  .thumbnail {
    width: 78px;
    height: 65px;
    display: block;
    border-radius: 6px;
    background-repeat: no-repeat;
    background-size: cover;
    margin: 0 13px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin: 0 7px;
      width: 58px;
      height: 50px;
      border-radius: 4px;
    }
  }
  .content-area {
    width: calc(100% - 265px);
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: calc(100% - 205px);
    }
    .name {
      color: #67696a;
      font-size: 10px;
      font-weight: 500;
      font-family: "Roboto", sans-serif;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
    }
    .subject {
      color: #67696a;
      font-size: 16px;
      font-weight: 500;
      font-family: "Roboto", sans-serif;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px;
      }
      .camp-name {
        max-width: 300px;
        margin-bottom: 0;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          max-width: 400px;
        }
      }
    }
  }
`;
